import { Component, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SlickCarouselComponent } from "ngx-slick-carousel";
import { IndustryHighlight } from '../../models/industry-highlights/industry-highlight.model';
import { IndustryHighlightsService } from '../../services/industry-highlights.service';

@Component({
  selector: 'safetydirector-industry-highlights',
  templateUrl: './industry-highlights.component.html',
  styleUrls: ['./industry-highlights.component.css']
})
export class IndustryHighlightsComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild("slickModal") slickModal: SlickCarouselComponent;
  private BusyA;
  public industry: string = '';
  public industryHighlights: IndustryHighlight[];

  slideConfig = {
    dots: false,
    infinite: true,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  };

  constructor(private industryHighlightsService: IndustryHighlightsService, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.activatedRoute.paramMap
      .subscribe(params => {
        this.industry = params.get('industry')!;
        this._getIndustryHighlights();
      });
  }

  private _getIndustryHighlights() {
    this.BusyA = this
      .industryHighlightsService
      .getIndustryHighlights(this.industry)
      .subscribe(result => {
        this.slickModal.unslick();
        this.industryHighlights = result.filter(x => x.url); //only include items that have a valid url, this should be required in SharePoint but this was added as a failsafe
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
  }

  ngOnDestroy(): void {
    if (this.BusyA) {
      this.BusyA.unsubscribe();
    }
  }

}
